import type { BlendMode, NodeId } from 'web';
import type { FlowGraph } from '../FlowGraph';
import type { BlendData } from '@/types/node';

export class BlendView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  setBlendMode(blendMode: BlendMode, ongoing: boolean) {
    const options = this.graph.store.getNodeData<BlendData>(this.nodeId).options;
    this.graph.wasmEdit((wasm) => wasm.setBlendOptions(this.nodeId, { ...options, blendMode }), ongoing);
    this.graph.updateNodeOutputs(this.nodeId, ongoing);
  }

  setOpacity(opacity: number, ongoing: boolean) {
    const options = this.graph.store.getNodeData<BlendData>(this.nodeId).options;
    this.graph.wasmEdit((wasm) => wasm.setBlendOptions(this.nodeId, { ...options, opacity }), ongoing);
    this.graph.updateNodeOutputs(this.nodeId, ongoing);
  }

  cancelOngoingAction() {
    this.graph.cancelOngoingAction();
  }
}
